import { UseQueryResult, useQuery } from '@tanstack/react-query'

import { pointsLeaderboardQueryOptions } from './query'
import { PointsLeaderboardEntry } from '../types'

export type UsePointsLeaderboardResult = Pick<UseQueryResult<PointsLeaderboardEntry[]>, 'data' | 'isLoading' | 'error'>

export function usePointsLeaderboard({ chainId }: { chainId: number }): UsePointsLeaderboardResult {
  const result = useQuery({
    ...pointsLeaderboardQueryOptions(chainId),
  })

  return {
    ...result,
    data: result.data,
  }
}
